"use client";

import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";

import { AnchorProvider } from "contexts/AnchorContext";
import { BrowserWalletConnectionProvider } from "contexts/BrowserWalletConnectionProvider";
import { CalloutBannerProvider } from "contexts/CalloutBannerContext";
import { MarinadeProvider } from "contexts/MarinadeContext";
import { PopupProvider } from "contexts/PopupContext";
import { PriorityFeeProvider } from "contexts/PriorityFeeContext";
import { SettingsPopupProvider } from "contexts/SettingsPopupContext";
import { ToastProvider } from "contexts/ToastContext";
import { WalletInfoProvider } from "contexts/WalletInfoContext";
import customTheme from "styles/customTheme";
import "../services/i18n";
import { BannerSection } from "tw/components/sections/BannerSection";

export function Providers({ children }: { children: ReactNode }) {
  const queryClient = new QueryClient();

  return (
    <ChakraProvider theme={customTheme}>
      {/* https://chakra-ui.com/docs/features/color-mode#for-nextjs */}
      <ColorModeScript initialColorMode={customTheme.config.initialColorMode} />

      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <BrowserWalletConnectionProvider>
            <WalletInfoProvider>
              <MarinadeProvider>
                <AnchorProvider>
                  <PriorityFeeProvider>
                    <CalloutBannerProvider>
                      <PopupProvider>
                        <SettingsPopupProvider>
                          <BannerSection>{children}</BannerSection>
                        </SettingsPopupProvider>
                      </PopupProvider>
                    </CalloutBannerProvider>
                  </PriorityFeeProvider>
                </AnchorProvider>
              </MarinadeProvider>
            </WalletInfoProvider>
          </BrowserWalletConnectionProvider>
        </ToastProvider>
      </QueryClientProvider>
    </ChakraProvider>
  );
}
